define(function(require) {
    const childView = require('./v_itv_edit_sites_search_results');

    return Marionette.CollectionView.extend({
        config:{},
        tagName: 'ul',
        ui:{
        },
        childEvents:{
            
        },
        childView:childView,
        className:'results-list',
        initialize:function(options){
            this.config = options.config;
        },
        onRender:function(){
        },
        childViewOptions:function(model, index){
            return {
                config:this.config
            }
        }
    });
});